export default function SpeczeLogo({ size = 36, showText = true, className = '' }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <radialGradient id="sg1" cx="40%" cy="35%" r="60%">
            <stop offset="0%" stopColor="#60a5fa"/>
            <stop offset="40%" stopColor="#8b3fff"/>
            <stop offset="100%" stopColor="#ec4899"/>
          </radialGradient>
          <radialGradient id="sg2" cx="35%" cy="30%" r="70%">
            <stop offset="0%" stopColor="rgba(255,255,255,0.35)"/>
            <stop offset="100%" stopColor="rgba(255,255,255,0)"/>
          </radialGradient>
        </defs>
        <circle cx="24" cy="24" r="22" fill="url(#sg1)" opacity="0.95"/>
        <circle cx="24" cy="24" r="22" fill="url(#sg2)"/>
        <path d="M 8 19 Q 16 13 24 19 Q 32 25 40 19" stroke="rgba(255,255,255,0.8)" strokeWidth="2.5" fill="none" strokeLinecap="round"/>
        <path d="M 8 25 Q 16 19 24 25 Q 32 31 40 25" stroke="rgba(200,160,255,0.65)" strokeWidth="2" fill="none" strokeLinecap="round"/>
        <path d="M 8 31 Q 16 25 24 31 Q 32 37 40 31" stroke="rgba(244,114,182,0.55)" strokeWidth="1.5" fill="none" strokeLinecap="round"/>
        <circle cx="24" cy="24" r="22" stroke="rgba(255,255,255,0.15)" strokeWidth="0.75" fill="none"/>
      </svg>
      {showText && (
        <span
          className="font-display font-bold text-transparent bg-clip-text select-none"
          style={{
            fontSize: size * 0.6,
            background: 'linear-gradient(135deg, #60a5fa 0%, #a855f7 50%, #ec4899 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}
        >
          Specze
        </span>
      )}
    </div>
  )
}
